// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3DWJ9","modalFooterButton":"ModalNotes_modalFooterButton__3jNGe"};